import { EvtHeader } from "components/header";
import React from "react";
import { useParams } from "react-router-dom";
import GradeForm from "../form";

const UpdateGrade = () => {
  const { gradeId } = useParams();

  return (
    <div className="flex-1 max-w-md">
      <EvtHeader title="Update Department" />
      <div className="p-6 max-w-2xl">
        <GradeForm gradeId={gradeId} />
      </div>
    </div>
  );
};

export default UpdateGrade;
